import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SalesSummaryCardComponent, DashboardKpiService, SalesSummaryEntity } from 'gung-dashboard';
import { ProductService, MetadataService } from 'gung-standard';

@Component({
    selector: 'colmec-sales-summary-card',
    templateUrl: './colmec-sales-summary-card.component.html',
    styleUrls: ['./colmec-sales-summary-card.component.scss'],
    standalone: false
})
export class ColmecSalesSummaryCardComponent extends SalesSummaryCardComponent {
  salesSummaryEntity = SalesSummaryEntity;

  constructor(
    protected dashboardKpiService: DashboardKpiService,
    protected translateService: TranslateService,
    protected productService: ProductService,
    protected metadataService: MetadataService
  ) {
    super(dashboardKpiService, translateService, productService);
  }
}
